<template>
    <q-dialog v-model="showModal" persistent>
        <q-card style="width: 400px; max-width: 60vw;">
            <q-card-section class="bg-form-bar">
                <q-item class="q-pa-none">
                    <q-item-section side>
                        <q-icon name="fa fa-image" color="white" size="md"/>
                    </q-item-section>

                    <q-item-section>
                        <q-item-label class="text-bold">Photo: {{ userData.first_name }} {{userData.middle_name}} {{userData.last_name}}</q-item-label>
                    </q-item-section>
                </q-item>
            </q-card-section>

            <q-card-section>
                <q-inner-loading style="z-index: 999" :showing="loading">
                    <q-spinner-dots size="100px" color="primary"/>
                </q-inner-loading>
                <user-image-form v-model="userObj" :current-photo="userData.profile_photo"/>
            </q-card-section>

            <q-card-actions align="right">
                <q-btn flat :label="$t('cancel')" color="primary" v-close-popup/>
                <q-btn :label="$t('save')" color="primary" @click="save" :loading="loading" v-if="!userData.profile_photo"/>
                <div v-else>
                    <q-btn :label="$t('delete')" color="negative" @click="makeSure" :loading="loading" v-if="!deleteImage"/>
                    <q-btn :label="$t('click_to_confirm')" color="warning" @click="destroy" :loading="loading" v-else/>
                </div>
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>
<script>

import UserImageForm from "./UserImageForm.vue";
import User from "../../models/User"

export default {
    name: "UserImageDialog",
    model: {
        prop: 'open',
        event: 'change'
    },
    props: {
        open: {
            type: Boolean,
            default: false
        },
        userId: {
            type: Number,
            required: true
        },
        userData: {
            type: Object,
            required: true
        }
    },
    computed: {
        showModal: {
            get: function () {
                return this.open
            },
            set: function (value) {
                this.$emit('change', value)
            }
        }
    },
    data() {
        return {
            loading: false,
            userObj: new User({
                id: this.userId,
                image: {},
            }),
            deleteImage: false
        }
    },
    methods: {
        save() {
            this.loading = true
            this.userObj.storeImage((url) => {
                this.loading = false
                this.showModal = false
                this.userObj.image = {}
                this.$emit('saved', url)
            }).catch(error => {
                this.loading = false
            })
        },
        makeSure() {
            this.deleteImage = true
            setTimeout(() => {
                this.deleteImage = false
            }, 3000)
        },
        destroy() {
            this.loading = true
            this.deleteImage = true
            this.userObj.deleteImage(() => {
                this.loading = false
                this.showModal = false
                this.userObj.image = {}
                this.$emit('deleted')
            }).catch(error => {
                this.loading = false
            })
        }
    },
    created() {
    },
    mounted() {

    },
    watch: {},
    components: {UserImageForm},
}
</script>
<style>

</style>
